/**
 * 网站静态资源配置
 * 注意：背景图片和Logo建议存放在本地，避免数据库查询延迟
 * 使用方法：将图片放入 frontend/public/images/ 目录，然后在下方配置路径
 */
export default {
  // 网站背景图片（建议尺寸：1920x1080 或更大）
  // backgroundImage: '/images/background.jpg',

  // 网站Logo
  logoImage: '/images/logo.jpg',

  // 网站标题（显示在导航栏）
  siteTitle: '韦小布AI',

  // 网站版本
  version: '1.0.5'
}